import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MapComponent } from './components';
import { fromMap, MapEffects } from '@iot-platform/data-access/maps';
@NgModule({
  imports: [MapComponent, StoreModule.forFeature(fromMap.featureKey, fromMap.reducers), EffectsModule.forFeature([MapEffects])],
  exports: [MapComponent]
})
export class IotPlatformMapsModule {}
